import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  actionButton: {
    cursor: 'pointer',
  },
  redButtonColor: {
    color: '#9E2B25',
  },
}));
